<template>
  <div class="fail-box">
    <div class="fail-title">真的要放弃升级高级版吗？</div>
    <div class="vip-group">
      <div class="vip-item" v-for="(item, index) in failInfo" :key="index">
        <img class="vip-icon" :src="item.icon" />
        <div>{{ item.title }}</div>
      </div>
    </div>
    <div class="handle-fail" @click="contill">继续支付</div>
    <div class="handle-fail">
      <button class="btn-manage" @click="contactCustomerService">
        咨询客服
      </button>
    </div>
    <div class="handle-fail cancel" @click="closeDialog">残忍放弃</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      failInfo: [
        {
          title: "不限作答人数",
          icon:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-05-15/00e19c86e01ec7dd10b933e3be1d2558.svg"
        },
        {
          title: "更多出题数",
          icon:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-05-15/7b0babd404a539d9189f4fb2b8283b37.svg"
        },
        {
          title: "防作弊",
          icon:
            "	https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-05-15/6908cc2b3518a99eb354607211a055fd.svg"
        },
        {
          title: "答完抽奖",
          icon:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-05-15/683bb21a20d99939d3b11eb6c18bedac.svg"
        },
        {
          title: "试题分析",
          icon:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-05-15/cf820e1269b9bc44ee3af1ba2a36ea6c.svg"
        },
        {
          title: "纯净无推广",
          icon:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-05-15/e525586f23b67804040ab66ac421459b.svg"
        }
      ]
    };
  },
  methods: {
    contill() {
      this.$emit('continuePay')
    },
    contactCustomerService() {
       this.$emit('closeFail', 2)
    },
    closeDialog() {
      this.$emit('closeFail', 1)
    }
  }
};
</script>
<style lang="scss" scoped>
.fail-box {
  width: 300px;
}

.vip-group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-around;
}

.vip-item {
  text-align: center;
  width: 90px;
  font-size: 12px;
}

.vip-icon {
  width: 35px;
  height: 35px;
}

.fail-title {
  height: 71px;
  background: linear-gradient(109deg, #005ae7 18%, #4293f3 89%);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  border-radius: 10px 10px 0 0;
}

.vip-group {
  background: #ffffff;
  padding: 10px 10px 25px;
}

.vip-item {
  margin-top: 15px;
}

.handle-fail {
  background: #ffffff;
  height: 51px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1890ff;
  font-size: 16px;
  cursor: pointer;
  border-top: 1px solid #EEEEEE;
}

.handle-fail.cancel {
  color: #999999;
}

.btn-manage {
  font-size: 16px;
  color: #1890ff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/payfail.vue